import { atom } from "jotai";

export const answerCountAtom = atom(0);
